import React from "react";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
//local
import {IconTrashCan} from "components/icons";

export const SignContractDraftButton = ({loading, onClick}) => (
  <ButtonTransparent
    name="SIGN_CONTRACT_ACTION_BUTTON_TO_DRAFT"
    small
    color="red"
    icon={<IconTrashCan />}
    loading={loading}
    onClick={onClick}
    addClass="mr-4"
  />
);
